<yc-modal
  [modalHeader]="healthIndicatorStats.healthIndicatorName"
  [modalSubHeader]="'MANAGE:hdrHealthIndicatorErrorCountDynamic' | ycI18n: 'Error Count: __healthIndicatorErrorCount__' : { healthIndicatorErrorCount: healthIndicatorStats.healthIndicatorErrorCount }"
  [primaryButtonText]="'common:textClose' | ycI18n: 'Close'"
  (onPrimaryClick)="closeModal.emit()">

  <div class="table-wrapper">
    <table class="table yc-table">
      <thead class="table-col-sticky">
        <tr>
          @for (header of headers; track header) {
            <th>
              {{header}}
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (detail of details; track detail) {
          <tr>
            @for (header of headers; track header) {
              <td>
                {{detail[header]}}
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
</yc-modal>